import React from 'react';
import './News.css';

function News() {
  const newsArticles = [
    {
      date: 'November 22, 2024',
      title: 'Introducing ‘PediaBright’: CKD Children’s Books Aim to Bridge Communication Gaps',
      author: 'American Academy of Pediatrics',
      description:
        'Communicating with patients can be one of the most challenging parts of a pediatric nephrologists’ job. Pediatricians share the room with two stakeholders, the patient and the parent. Each party has their own anxieties and concerns, and depending on the patient’s age...',
      image: '/images/color_circles_2.png',
      link: '/articles/AAP_Article.pdf',
    },
    {
      date: 'December 13, 2021',
      title: 'MHA Candidate Meghan Weihmuller Creates Children’s Health Startup PediaBright',
      author: 'By Prasana Ruxmohan',
      description:
        'As a first-year Master of Health Administration candidate, Meghan Weihmuller was looking for a way to foster health literacy while incorporating innovation and health equity. With this in mind, Weihmuller started the children’s health-focused startup, PediaBright.',
      image: '/images/color_circles_2.png',
      link: 'https://www.slu.edu/public-health-social-justice/news/2021/weihmuller-meghan.php',
    },
  ];

  return (
    <div className="news-container">
      <h1 className="news-header">NEWS</h1>
      <div className="news-articles">
        {newsArticles.map((article, index) => (
          <a
            href={article.link}
            target="_blank"
            rel="noopener noreferrer"
            className="news-card"
            key={index}
          >
            {/*<img src={article.image} alt="News" className="news-image" />*/}
            <div className="news-content">

              <h2 className="news-title">{article.title}</h2>
              <p className="news-author">{article.author}</p>
              <p className="news-author">{article.date}</p>
              <p className="news-description">{article.description}</p>
              <div className="news-read-more">READ MORE</div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default News;
